import React from "react";
import { Form } from "react-bootstrap";
import { FieldValidation } from "../useCreateWizard";

interface BaseValidatedFormGroupProps {
    children: React.ReactNode;
    validation?: FieldValidation;
    className?: string;
    controlId?: string;
}

export const BaseValidatedFormGroup: React.FC<BaseValidatedFormGroupProps> = ({
    children,
    validation,
    className = "",
    controlId,
}) => {
    const hasError = validation && !validation.isValid && validation.errorMessage;
    const hasWarning = validation && validation.warningMessage;

    return (
        <Form.Group className={`${className} ${hasError ? "has-validation-error" : ""}`} controlId={controlId}>
            {children}

            {/* Error feedback */}
            {hasError && (
                <div className="text-danger small mt-1">
                    <i className="bi bi-exclamation-circle me-1"></i>
                    {validation.errorMessage}
                </div>
            )}

            {/* Warning feedback */}
            {hasWarning && (
                <div className="text-warning small mt-1">
                    <i className="bi bi-exclamation-triangle me-1"></i>
                    {validation.warningMessage}
                </div>
            )}
        </Form.Group>
    );
};
